import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { buildLoginRedirectPath } from '../lib/authRedirect';
import { isRestrictedBoardMember } from '../lib/boardMemberAccess';
import { RouteFallback } from './RouteFallback';

export function RestrictedBoardMemberRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <RouteFallback />;
  }

  if (!user) {
    return (
      <Navigate
        to={buildLoginRedirectPath(`${location.pathname}${location.search}${location.hash}`)}
        replace
      />
    );
  }

  if (isRestrictedBoardMember(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
